<template>
  <main>
    <section class="list">
      <div class="container">
        <h1>Ceník</h1>
        <p>Platný od 01/2026</p>
        <div class="row">
          <div class="col-md-12 columned">
            <div class="list-item">
              <h2>Kosmetika NATINUEL/G. M. Collin</h2>
              <ul>
                <li>
                  Základní kosmetické ošetření dle typu pleti, cca 60min
                  <label>1250,-Kč</label>
                </li>
                <!-- <li>
                  Základní kosmetické ošetření dle typu pleti, cca 60min
                  (Senioři 70+)<label>1150,-Kč</label>
                </li> -->
                <!-- <li>Hydratační ošetření<label>1050,-Kč</label></li>
                <li>Mandlové ošetření<label>1050,-Kč</label></li> -->
                <li>Akné ošetření junior (do 20 let)<label>950,-Kč</label></li>
                <!-- <li>Ošetření kuperózy<label>1050,-Kč</label></li> -->
                <!-- <li>Liftingové ošetření<label>1150,-Kč</label></li> -->
                <!-- <li>Anti - Aging ošetření<label>1350,-Kč</label></li>
                <li>
                  Anti - Aging ošetření + mezoterapie (cca 90min)
                  <label>1450,-Kč</label>
                </li> -->
                <!-- <li>Chemický peeling (zimní)<label>1050,-Kč</label></li> -->
                <li>
                  Peelingové ošetření RX50 (celoroční)<label>1350,-Kč</label>
                </li>
                <li>
                  Peelingové ošetření Revinol (zimní)<label>1250,-Kč</label>
                </li>
                <li>
                  Ošetření Rx Carboxy-biostimulační , vedoucí k tvorbě
                  kolagenu<label>1500,-Kč</label>
                </li>
                <li>
                  Ošetření Rx Carboxy +kuperóza - biostimulační , protizánětlivé
                  zaměřené na kuperózu<label>1500,-Kč</label>
                </li>
                <li>
                  Exosomy+RX Carboxy - mimořádně silné , velmi komfortní<label>1700,-Kč</label>
                </li>
                <li>
                  <span
                    ><b>Novinka 2026 Ošetření s EXO Hyal Complex /LED lampa</b>, genová biostimulace pleti, hluboká
regenerace, dlouhodobé omlazení</span
                  ><label>1850,-Kč/cca 70minut</label>
                </li>
                <li>
                  <span
                    ><b>Novinka 2026 ošetření EXO Carbo Biostim /Mezoterapie</b>, zesílená regenerace, preventivní
ochrana ECM(extracelulární matrix)</span
                  ><label>2200,-Kč/cca 70minut</label>
                </li>
                <li>
                  <span
                    ><b>Novinka 2026 ošetření EXO BIO MATRIX /Mezoterapie</b>,pokročilá buněčná obnova,
regenerace kmenových buněk , aktivace fibroplastů, hluboká hydratace</span
                  ><label>3100,-Kč/cca 70minut</label>
                </li>
                <li>
                  <span
                    ><b>Novinka 2026 G.M.Collin Sea C Spa anti-aging s vitamínem C+mořské řasy+termální
bahno.</b>Luxusní anti-aging s antioxidačním účinkem.</span
                  ><label>2900,-Kč/cca 60minut</label>
                </li>
                <!-- <li>
                  Novinka 2025 ošetření s Exosomy+RX Carboxy - mimořádně silné ,
                  velmi komfortní<label>1950,-Kč</label>
                </li>
                <li>
                  <span
                    ><b>Novinka 2025 Ošetření s Exosomy+RX</b> Carboxy+Bio
                    MEC/BIO Oxy - <b>MEZOTERAPIE</b> pomocí dermálního pera
                    umožŇuje hlubší působení a maximalizuje regenerační a
                    omlazující účinky</span
                  ><label>2200,-Kč</label>
                </li>
                <li>
                  <span
                    ><b>Novinka 2025 Ošetření s Exosomy+RX</b> Carboxy+Skin
                    Normalize/Skin Restructure - <b>MEZOTERAPIE</b> pomocí
                    dermálního pera umožŇuje hlubší působení a maximalizuje
                    regenerační a omlazující účinky</span
                  ><label>2500,-Kč</label>
                </li> -->
              </ul>
              <ul>
                <li>
                  Zábal na ruce - hloubková hydratace pro sametově hebkou pokožku<label>390,-Kč</label>
                </li>
                <li>
                  Galvanická žehlička NuSkin (cca 30min)<label>550,-Kč</label>
                </li>
                <li>Ultrazvuková špachtle (cca 30min)<label>550,-Kč</label></li>
                <li>Parafín na ruce (cca 20min)<label>250,-Kč</label></li>
              </ul>
              <ul>
                <li>Barvení obočí<label>100,-Kč</label></li>
                <li>Úprava obočí<label>100,-Kč</label></li>
                <li>Úprava a barvení obočí<label>180,-Kč</label></li>
                <!-- <li>Úprava a barvení obočí (Senioři)<label>150,-Kč</label></li> -->
                <!-- <li>Úprava a barvení obočí (Studenti)<label>150,-Kč</label></li>
                <li>Laminace obočí<label>450,-Kč</label></li>
                <li>3D rekonstrukce obočí<label>550,-Kč</label></li> -->
                <li>Barvení řas<label>100,-Kč</label></li>
              </ul>
            </div>
            <div class="list-item">
              <h2>Depilace</h2>
              <ul>
                <li>
                  Obličej (horní ret, brada, tváře, spánky)<label
                    >350,-Kč</label
                  >
                </li>
                <li>Horní ret<label>90,-Kč</label></li>
                <li>Brada<label>90,-Kč</label></li>
                <!-- <li>Lýtka<label>350,-Kč</label></li>
                <li>Celé nohy<label>600,-Kč</label></li> -->
              </ul>
            </div>
            <div class="list-item">
              <h2>Masáže</h2>
              <ul>
                <li>
                  Klasicka,zdravotní - záda a šíje (30min)<label>450,-Kč</label>
                </li>
                <li>
                  Permanentka (záda a šíje) 5 vstupů<label>1450,-Kč</label>
                </li>
                <li>
                  Klasicka celková (záda,šíje,nohy,ruce) (60min)
                  <label>750,-Kč</label>
                </li>
                <li>Masáž lávovými kameny (30min)<label>650,-Kč</label></li>
                <li>Masáž lávovými kameny (60min)<label>950,-Kč</label></li>
                <li>
                  Lymfodrenáž ruční - krk,ruce,nohy (60min)
                  <label>850,-Kč</label>
                </li>
                <li>Balíček : 5x Lymfodrenáž (60min)<label>3500,-Kč</label></li>
                <li>
                  Lymfodrenáž ruční - krk,ruce,nohy,hlava,záda (90min)
                  <label>1150,-Kč</label>
                </li>
                <!-- <li>Balíček : 5x Lymfodrenáž (90min)<label>4500,-Kč</label></li> -->
                <!-- <li>
                  Reflexní terapie (plosky nohou) (30min)<label>350,-Kč</label>
                </li> -->
                <li>Kraniosakrální terapie (40min)<label>500,-Kč</label></li>
                <li>
                  Balíček : 4x Kraniosakrální terapie<label>1700,-Kč</label>
                </li>
              </ul>
              <!-- <h3>Lipo M6 (40min)</h3>
              <ul>
                <li>1 ošetření<label>1000,-Kč</label></li>
                <li>10 ošetření<label>7500,-Kč</label></li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
